import angular from 'angular';

import uibCollapse from 'angular-ui-bootstrap/src/collapse';
import ngAnimate from 'angular-animate';

// Component
import formComponent from './recapResponseFormResponse.component';

import translationModuleName from '../../translation';

// TODO: Move this component to shared lib directory
import confirmModal from '../modals/confirmModal';

let module = angular.module('recaps.components.recapResponseFormResponse', [
  uibCollapse,
  ngAnimate,
  confirmModal.name,
  translationModuleName,
]);

module.component('recapResponseFormResponse', formComponent);

export default module;
